import React from "react"
import Label from "components/general/Label"
import Competitor from 'components/presentation/Competitor';

const Interference = ({ data }) => {
  let interference = []  
  data.forEach((result) => {
    const waves = result?.extendedResults && result?.extendedResults.filter(res => res.er_code === 'WAVE')
    const wave = (waves) ? waves[waves.length - 1] : null
    if (wave && wave?.er_irm){
      interference.push(<div className="mx-1"><Competitor
          key={`interference-component-${interference.length}`}
          hidePicture={true}
          hideNoc={true}
          {...result?.participant}                      
      /></div>)
    } 
  })
  

  return (
    <>
    {(interference.length > 0)
      ? (
        <div className="mb-3 d-flex">
          <div className="mx-1"><Label data="LabelInterference" />: </div>
          {interference}
        </div>  
      ) : ('')
    }
    </>
  );
}

export default Interference;